import { useEffect, useRef } from "react";

type UseInfiniteScrollOptions = {
  enabled: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
  rootMargin?: string;
};

export default function useInfiniteScroll({
  enabled,
  isLoading,
  onLoadMore,
  rootMargin = "320px",
}: UseInfiniteScrollOptions) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!enabled || isLoading) return;
    const node = sentinelRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry?.isIntersecting) {
          onLoadMore();
        }
      },
      { rootMargin },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [enabled, isLoading, onLoadMore, rootMargin]);

  return sentinelRef;
}
